// Homepage "From our school Media Box" section settings.
//
// YouTube videos are fetched LIVE from the WSTSC channel: every new upload
// appears on the homepage automatically, with no code change or redeploy.
// The browser asks /youtube-feed.php (public/youtube-feed.php), which reads the
// channel's public RSS feed on the server and caches it for 30 minutes.
//
// Full guide: docs/social-media.md

export const youtubeFeed = {
  endpoint: "/youtube-feed.php",
  // How many videos to show (1 featured + the rest in the sliding list, 4
  // visible at a time). Leave out or set 0 to show every video.
  // limit: 10,
  // YouTube Shorts are vertical; set true to include them.
  includeShorts: true,
  // Optional: a video id to keep as the large featured video (e.g. an event
  // highlight). Leave "" to feature the newest upload.
  pinnedVideoId: "",
  // Videos that must never appear on the website, e.g. no family consent for
  // the website, or not suitable for the homepage. Paste the id from the
  // video's URL (youtube.com/watch?v=THIS_PART).
  hiddenVideoIds: [],
};

// Every video on the WSTSC channel (all 16 as of 25 Sep 2026), newest first.
// - Titles are exactly as on YouTube; dates are the Sydney upload date.
// - `summary` is a short English line from the video's own description, so
//   parents who don't read Tamil know what they are opening.
// - `thumbnailAlt` describes the thumbnail image for screen readers.
// The live feed uses these details when a video is listed here, falls back
// to this list if YouTube can't be reached, and lets a pinned video older than
// the feed's newest 15 still be featured. New uploads appear on the homepage
// without being added here; `npm run social:latest` shows any that are missing
// so a summary and alt text can be written.
// Thumbnails showing identifiable children (check consent): g6DMT8bRVIE,
// gMw6KqB4P1Q, qD8EkHMm2Fo, HJkeXh-NYhA.
export const channelVideos = [
  {
    id: "z-4zxqqPHc4",
    title: "விலங்குகளின் ஓசைகள் 🦁🐯 | Animal Sounds in Tamil | Tamil Kids Song",
    date: "2026-09-20",
    summary: "A fun Tamil children's song about the sounds animals and birds make. How does a lion roar?",
    thumbnailAlt: "Cartoon lion roaring in a meadow, captioned சிங்கம் (lion)",
  },
  {
    id: "SdggPGWrQUo",
    title: "ஆடிப் பாடி மகிழ்வோம்! | Sing, Dance & Play | Tamil Kids Song",
    date: "2026-08-28",
    summary: "A cheerful Tamil action song for children: run, jump, swim, dance and have fun with friends.",
    thumbnailAlt: "Four cartoon children standing in a sunny park",
  },
  {
    id: "XKFl2F-rKaM",
    title: "WSTSC – ஆத்திசூடி நிகழ்வு | ஒளவையார் அரங்கம் 2026",
    date: "2026-08-19",
    summary: "Our students present Aathichoodi, Avvaiyar's classic Tamil verses, at the WSTSC Avvaiyar Arangam.",
    thumbnailAlt: "Illustration of the poet Avvaiyar with the words ஒளவையார் அரங்கு",
  },
  {
    id: "K-zIvJxbRys",
    title: "அப்பா என் அப்பா | Appa En Appa | Tamil Kids Song",
    date: "2026-08-12",
    summary: "A gentle Tamil children's song about the special bond between a father and his daughter.",
    thumbnailAlt: "Cartoon father hugging his young daughter in a garden",
  },
  {
    id: "0lSbebH4meE",
    title: "தொப்பி வியாபாரியும் குரங்குகளும் Western Sydney Tamil Study Centre",
    date: "2026-08-07",
    summary: "The Hat Seller and the Monkeys, a fun Tamil moral story. How does the clever hat seller get his hats back?",
    thumbnailAlt: "Cartoon monkeys wearing colourful knitted hats",
  },
  {
    id: "FQkybaiwmsk",
    title: "ஆடிப்பிறப்பு சிறப்பு நிகழ்வு 2026 - Western Sydney Tamil Study Centre",
    date: "2026-07-30",
    summary: "Students celebrate Aadi Pirappu 2026, sharing their love of Tamil language, art and tradition.",
    thumbnailAlt: "Festive title card reading ஆடிப்பிறப்பு சிறப்பு நிகழ்வு with oil lamps and flowers",
  },
  {
    id: "rz4qLWYOqBo",
    title: "✨ WSTSC Dinner Night 2026 ✨  Western Sydney Tamil Study Centre",
    date: "2026-07-05",
    summary: "Highlights from the WSTSC Dinner Night 2026.",
    thumbnailAlt: "Illustration of a classical dancer beside a Western Sydney Tamil Study Centre banner",
  },
  {
    id: "g6DMT8bRVIE",
    title: "✨ WSTSC மாணவர்களின் நடனம்✨ WSTSC Dinner Night 2026 | Event ✨",
    date: "2026-07-02",
    summary: "Our students perform a dance at the WSTSC Dinner Night 2026.",
    thumbnailAlt: "Students in traditional dance costume with their teachers",
  },
  {
    id: "gMw6KqB4P1Q",
    title: "✨ WSTSC இரவு விருந்து 2026 – சிறப்புத் தருணங்கள் - ✨ WSTSC Dinner Night 2026 | Event Highlights ✨",
    date: "2026-06-24",
    summary: "Performances, music and community moments from the WSTSC Dinner Night 2026.",
    thumbnailAlt: "Students in traditional costume dancing in a hall",
  },
  {
    id: "qD8EkHMm2Fo",
    title: "கதையுடன் விளையாடி கற்ற எங்கள் மாணவர்கள் - Fun, Learning and Adventure in the Great Outdoors",
    date: "2026-06-01",
    summary: "Our young learners act out the story The Monkey and the Cap Seller through outdoor play, guided by their teachers.",
    thumbnailAlt: "Students, teachers and parents outdoors, with the words Learning, Culture, Community",
  },
  {
    id: "aHaR3u2leQU",
    title: "WSTSC – சித்திரைப் புத்தாண்டு சிறப்பு நிகழ்வு 2026 - பகுதி 2",
    date: "2026-05-31",
    summary: "Part 2 of our Tamil New Year (Chithirai Puthandu) 2026 celebration, with student speeches and cultural items.",
    thumbnailAlt: "Chithirai Puthandu 2026 Part 2 title card with a temple, oil lamp and fruit",
  },
  {
    id: "yVgYAm8ukj4",
    title: "WSTSC – சித்திரைப் புத்தாண்டு சிறப்பு நிகழ்வு 2026 - பகுதி 1",
    date: "2026-05-15",
    summary: "Part 1 of our Tamil New Year (Chithirai Puthandu) 2026 celebration, with student speeches and cultural items.",
    thumbnailAlt: "Chithirai Puthandu 2026 title card with a brass lamp, coconut and bananas",
  },
  {
    id: "MRz4t6j3GLk",
    title: "Special Assembly at WRPS | Western Sydney Tamil Study Centre",
    date: "2026-05-04",
    summary: "Students, teachers, parents and volunteers mark the start of our journey at Walters Road Public School.",
    thumbnailAlt: "WSTSC and Walters Road Public School flyer showing children learning together",
  },
  {
    id: "HJkeXh-NYhA",
    title: "Western Sydney Tamil Study Centre (மேற்கு சிட்னி தமிழ் கல்வி நிலையம்) மாணவர்களின் சிறுவர் சந்தை",
    date: "2026-03-14",
    summary: "Students run their own stalls at the WSTSC Kids' Market, building confidence and small-business skills.",
    thumbnailAlt: "Students selling fruit and vegetables at market stalls",
  },
  {
    id: "NYV6yeyK7NE",
    title: "Western Sydney Tamil Study Centre  - மேற்கு சிட்னி தமிழ் கல்வி நிலையம் - பொங்கல் விழா 2026",
    date: "2026-02-17",
    summary: "Our Pongal Festival 2026 on 7 February, with the traditional Pongal pot, folk performances and a traditional dress parade.",
    thumbnailAlt: "The word பொங்கல் above a bowl of rice and a glowing lamp",
  },
  {
    id: "vwTExtFmaeM",
    title: "WSTSC Open Day 25-10-2025 visit by the Hon. Chris Bowen MP",
    date: "2026-02-09",
    summary: "The Hon. Chris Bowen MP visits the WSTSC Open Day on 25 October 2025.",
    thumbnailAlt: "The Hon. Chris Bowen MP speaking to families at the WSTSC Open Day",
  },
];

// Facebook and Instagram posts to feature (these stay hand-picked: Meta has no
// public feed, and its API needs a server-side token). Empty until WSTSC
// chooses posts approved for the website; the section then shows them.
// Save each image in public/social/ (about 600x600 px, JPG) - Meta's image
// links expire, so they can't be linked directly.
//
// {
//   platform: "instagram",                    // or "facebook"
//   url: "https://www.instagram.com/p/POST_ID/", // the post's own link
//   image: "/social/pongal-2026.jpg",
//   imageAlt: "Students in traditional dress making Pongal",
//   caption: "Pongal celebration 2026 at WSTSC",
//   date: "2026-01-18",
// },
export const socialPosts = [];
